// Special separator for building links in HyperDrive
export const QUERY_SEPARATOR = '%7c';
// eslint-disable-next-line no-template-curly-in-string
export const FEATURES_KEYS = '${keys}';
export const COMMON_ANCHOR_ID_SCROLL_TO = 'learn-more-id-section';
export const DEFAULT_LANG = 'en';
export const EUROPEAN_UNION = 'eu';
export const DEFAULT_CURRENCY = 'EUR';
export const STYLE_TYPE = 'currency';
// Options for attr 'target'
export const SELF = '_self';
export const BLANK = '_blank';
export const MOBILE = 'MOBILE';
export const TABLET = 'TABLET';
export const DESKTOP = 'DESKTOP';
export const LARGE_DESKTOP = 'LARGE_DESKTOP';
// Postfix for diff images url
const THUMBNAIL_IMAGE_SUFFIX = '_Thumbnail';
const MOBILE_IMAGE_SUFFIX = '_Mobile';
const TABLET_IMAGE_SUFFIX = '_Tablet';
export const THUMBNAIL_KEY = 'thumbnail';
export const MOBILE_KEY = 'mobile';
export const TABLET_KEY = 'tablet';
export const DESKTOP_KEY = 'desktop';
export const IMG_POSTFIX = {
    thumbnail: THUMBNAIL_IMAGE_SUFFIX,
    mobile: MOBILE_IMAGE_SUFFIX,
    tablet: TABLET_IMAGE_SUFFIX,
    desktop: '',
};
export const keyCodes = {
    ARROW_LEFT: 'ArrowLeft',
    ARROW_RIGHT: 'ArrowRight',
    ARROW_UP: 'ArrowUp',
    ARROW_DOWN: 'ArrowDown',
    ESCAPE: 'Escape',
    ENTER: 'Enter',
    TAB: 'Tab',
};
export const EVENT_NAME_MAP = {
    click: 'click',
    mouseDown: 'mousedown',
};
const textBody16 = {
    font: 'Ubuntu',
    weight: 400,
    size: 16,
    lineHeight: 24,
};
const textBody18 = {
    font: 'Ubuntu',
    weight: 400,
    size: 18,
    lineHeight: 28,
};
const textBody24 = {
    font: 'Ubuntu',
    weight: 400,
    size: 24,
    lineHeight: 32,
};
export const TYPOGRAPHY_MAP = {
    textBody16,
    textBody16Medium: {
        ...textBody16,
        weight: 500,
    },
    textBody18,
    textBody18Medium: {
        ...textBody18,
        weight: 500,
    },
    textBody24,
    textBody24Medium: {
        ...textBody24,
        weight: 500,
    },
};
// TODO: (D.K) Need rename this option to 'AspectRatioParams'
export var AspectRatio;
(function (AspectRatio) {
    AspectRatio["RectangleLevel1"] = "32/9";
    AspectRatio["RectangleLevel2"] = "21/9";
    AspectRatio["RectangleLevel3"] = "16/9";
    AspectRatio["RectangleLevel4"] = "9/5";
    AspectRatio["RectangleLevel5"] = "3/2";
    AspectRatio["RectangleLevel6"] = "4/3";
    AspectRatio["RectangleLevel7"] = "2/1";
    AspectRatio["VerticalRectangle"] = "2/3";
    AspectRatio["Square"] = "1/1";
    AspectRatio["Auto"] = "auto";
})(AspectRatio || (AspectRatio = {}));
export const METHOD_GET = 'GET';
export const METHOD_POST = 'POST';
export var GalleryItemType;
(function (GalleryItemType) {
    GalleryItemType["Action"] = "action";
    GalleryItemType["Static"] = "static";
    GalleryItemType["Studio"] = "studio";
    GalleryItemType["Detail"] = "detail";
    GalleryItemType["Degrees360"] = "360-degrees";
    GalleryItemType["VIEW360"] = "View360";
    GalleryItemType["VIDEO"] = "Video";
    GalleryItemType["IMAGE"] = "img";
})(GalleryItemType || (GalleryItemType = {}));
export const KEY_IMAGE = 'key';
export const STUDIO_IMAGE = GalleryItemType.Studio;
export const STATIC_IMAGE = GalleryItemType.Static;
export const ACTION_IMAGE = GalleryItemType.Action;
export const DEGREES_360 = GalleryItemType.Degrees360;
export var ImageSuffix;
(function (ImageSuffix) {
    ImageSuffix["Mobile"] = "_Mobile";
    ImageSuffix["Thumbnail"] = "_Thumbnail";
    ImageSuffix["SmallThumbnail"] = "_SmallThumbnail";
})(ImageSuffix || (ImageSuffix = {}));
export const YOUTUBE_LINK_START = 'https://www.youtube.com/embed';
export const YOUTUBE_PLAYLIST_LINK_START = `${YOUTUBE_LINK_START}/videoseries?list=`;
export const YOUTUBE_PREVIEW_IMAGE_URL = 'https://img.youtube.com/vi';
export const YOUTUBE_PREVIEW_IMAGE_NAME = 'maxresdefault.jpg';
export const YOUTUBE_THUMBNAIL_IMAGE_NAME = 'mqdefault.jpg';
export const ENABLE_JS_API = 'enablejsapi';
export const YAMAHA_LOGO_LINK = 'https://my.yamaha-motor.eu/resource/1696411106000/yamahaLogoSvg';
export var HTTPStatusCode;
(function (HTTPStatusCode) {
    HTTPStatusCode[HTTPStatusCode["OK"] = 200] = "OK";
    HTTPStatusCode[HTTPStatusCode["BadRequest"] = 400] = "BadRequest";
    HTTPStatusCode[HTTPStatusCode["Unauthorized"] = 401] = "Unauthorized";
    HTTPStatusCode[HTTPStatusCode["NotFound"] = 404] = "NotFound";
    HTTPStatusCode[HTTPStatusCode["UnprocessableContent"] = 422] = "UnprocessableContent";
    HTTPStatusCode[HTTPStatusCode["InternalServerError"] = 500] = "InternalServerError";
})(HTTPStatusCode || (HTTPStatusCode = {}));
export var Status;
(function (Status) {
    Status["OK"] = "OK";
    Status["FAILURE"] = "FAILURE";
    Status["CHANGE_STOCK"] = "CHANGE_STOCK";
    Status["EXPIRED_STATUS"] = "CART_EXPIRED";
    Status["ORDERED_STATUS"] = "CART_ORDERED";
})(Status || (Status = {}));
export const MAX_STOCK_VALUE = 20;
export var BroadcastChannels;
(function (BroadcastChannels) {
    BroadcastChannels["CART"] = "cart";
})(BroadcastChannels || (BroadcastChannels = {}));
export var CartBroadcastEvents;
(function (CartBroadcastEvents) {
    CartBroadcastEvents["ADD_NEW_PRODUCT"] = "cart_add_new_product";
    CartBroadcastEvents["REMOVE_PRODUCT"] = "cart_remove_product";
    CartBroadcastEvents["CHANGE_QUANTITY_PRODUCT"] = "cart_change_quantity_product";
    CartBroadcastEvents["CART_UPDATED"] = "cart_updated";
    CartBroadcastEvents["CART_FROM_URL"] = "cart_from_url";
})(CartBroadcastEvents || (CartBroadcastEvents = {}));
export const ASPECT_RATIO_CARD_COMMON_PARAMS = {
    sm: AspectRatio.RectangleLevel5,
    md: AspectRatio.RectangleLevel3,
    lg: AspectRatio.RectangleLevel3,
};
export const SHOWING_AMOUNT_TEMPLATE = '{showingAmount}';
export const OF_AMOUNT_TEMPLATE = '{ofAmount}';
// Local Storage keys
export const ACCESSORIES_COMPATIBILITY_KEY = 'CompatibilityProduct';
// TechHighlights constant
export const TECH_HIGHLIGHTS_MINIMAL_COUNTS = 2;
// Hostettler customer id {generated by v4}
export const EXTERNAL_CUSTOMER_ID = 'customerId';
export const MILES_IN_KM = 0.621371;
export const GB_COUNTRY_ROOT = 'gb';
export const YAMT = 'Y-AMT';
export const POWER_VERSION_35KW = '35 kW (A2 licence)';
export const DRIVER_LICENSE_A2 = 'A2';
export const MINIMUM_DATE = '0001-01-01T00:00:00Z';
